export const profileMessagesFrag = `
    id
    messageId
    readAt
    message {
        id
        title
        type
        content
        createdAt
        validFrom
        validTo
    }
`;
